import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { load } from 'ember-async-data';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import Button from 'umg-ember-backend/components/ui/button/index';
import imageUrl from 'umg-ember-backend/helpers/image-url';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordExplorerForMlpTemplatePreviewComponent extends Component {
  // Getter and setter
  get isSelected() {
    return this.args.selectedTemplate === this.args.template;
  }

  // Template
  <template>
    <div
      class={{bem (hash is-selected=this.isSelected)}}
      role='button'
      {{on 'click' (fn @selectTemplate @template)}}
      ...attributes
    >
      {{#let (load @template.thumbnail) as |result|}}
        {{#if result.isResolved}}
          <img
            src={{imageUrl result.value '4/480'}}
            class={{bem 'image'}}
            alt={{@template.headline}}
          />
        {{else if result.isPending}}
          {{t 'ui.loading'}}
        {{/if}}
      {{/let}}

      {{#if this.isSelected}}
        <div class={{bem 'selected-indicator'}}>
          {{svgJar 'selected' class='u-icon'}}
        </div>
      {{/if}}

      <div class={{bem 'show-preview'}}>
        <Button
          @style='outline'
          @icon='newspaper'
          @label={{t 'record_explorer.for.mlp.templates.preview.button'}}
          {{on 'click' (fn @previewTemplate @template)}}
        />
      </div>

      <div class={{bem 'name'}}>
        {{@template.displayLabel}}
      </div>
    </div>
  </template>
}
